module.exports = __webpack_public_path__ + "img/RUN-FOREFOOT-A-DROITE.cda67dd9.svg";